import * as THREE from "three";
import type { HelperLine } from "./types";

/**
 * The infinite lines the two ends of an edge slide along when the edge is offset — the lines
 * carrying the previous and the next edge. Either side is null at the open end of a chain.
 */
function getEdgeHelperLines({
	points,
	edgeIndex,
	isLoop,
}: {
	points: ReadonlyArray<THREE.Vector3>;
	edgeIndex: number;
	isLoop: boolean;
}): { previous: HelperLine | null; next: HelperLine | null } | null {
	const pointCount = points.length;
	const edgeCount = isLoop ? pointCount : pointCount - 1;

	if (edgeIndex < 0 || edgeIndex >= edgeCount) {
		return null;
	}

	const start = points[edgeIndex];
	const end = points[(edgeIndex + 1) % pointCount];

	const hasPrevious = isLoop || edgeIndex > 0;
	const hasNext = isLoop || edgeIndex < edgeCount - 1;

	const previousPoint = hasPrevious ? points[(edgeIndex - 1 + pointCount) % pointCount] : null;
	const nextPoint = hasNext ? points[(edgeIndex + 2) % pointCount] : null;

	return {
		previous:
			previousPoint === null
				? null
				: {
						point: previousPoint.clone(),
						direction: new THREE.Vector3(start.x - previousPoint.x, 0, start.z - previousPoint.z),
					},
		next:
			nextPoint === null
				? null
				: {
						point: nextPoint.clone(),
						direction: new THREE.Vector3(end.x - nextPoint.x, 0, end.z - nextPoint.z),
					},
	};
}

export { getEdgeHelperLines };
